export default __webpack_public_path__ + "static/media/affligem_logo.6346341b.svg";